import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  title: {
    fontFamily: 'Raleway',
    fontWeight: 700,
    fontSize: 48,
    lineHeight: 1,
    letterSpacing: 0,
    textAlign: 'center',
  },
  subtitle: {
    fontFamily: 'Raleway',
    fontWeight: 400,
    fontSize: 24,
    lineHeight: 1.3,
    letterSpacing: 0,
    textAlign: 'center',
  },
}))

export default useStyles
